// @ts-nocheck
// Ρυθμίσεις → «Εταιρίες»: δυναμική διαχείριση financial_entities (rentable, multi-tenant).
// list + create/edit + deactivate/activate + delete (μόνο αν 0 κινήσεις· αλλιώς ask→deactivate).
import React, { useState, useEffect } from 'react';
import authService from './authService';

const EMPTY = { code: '', name: '', vat: '', doy: '', entity_type: 'NEPA', address: '', is_active: true };

const EntitiesManager: React.FC = () => {
  const user = authService.getCurrentUser();
  const code = user?.code || '';

  const [rows, setRows] = useState<any[]>([]);
  const [types, setTypes] = useState<string[]>([]);
  const [showInactive, setShowInactive] = useState(false);
  const [editing, setEditing] = useState<any>(null); // null | {..entity, _isNew?}
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);

  const api = (qs: string, opts: any = {}) =>
    fetch('/api/financial-entities.php' + qs, {
      method: opts.method || 'GET',
      headers: { 'Content-Type': 'application/json', 'X-Employee-Code': code },
      ...(opts.body ? { body: JSON.stringify(opts.body) } : {}),
    });

  const load = async () => {
    setLoading(true);
    try {
      const r = await api('?action=list' + (showInactive ? '&include_inactive=1' : ''));
      const j = await r.json();
      if (!r.ok) { setMsg(j.error || 'Σφάλμα φόρτωσης'); return; }
      setRows(j.entities || []); setTypes(j.types || []);
    } catch (e) { setMsg('Σφάλμα δικτύου'); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [showInactive]);

  const save = async () => {
    const e = editing;
    if (!e.name.trim()) { setMsg('Επωνυμία υποχρεωτική'); return; }
    if (e._isNew && !/^[A-Za-z0-9]{1,10}$/.test(e.code.trim())) { setMsg('Διακριτικό: 1-10 λατινικά/αριθμοί (π.χ. NEPA3)'); return; }
    const action = e._isNew ? 'create' : 'update';
    const r = await api('?action=' + action, { method: 'POST', body: e });
    const j = await r.json();
    if (!r.ok || !j.success) { setMsg('❌ ' + (j.error || 'Σφάλμα')); return; }
    setMsg('✅ Αποθηκεύτηκε'); setEditing(null); await load();
  };

  const toggleActive = async (row: any) => {
    const action = row.is_active ? 'deactivate' : 'activate';
    const r = await api('?action=' + action, { method: 'POST', body: { code: row.code } });
    const j = await r.json();
    if (!r.ok || !j.success) { setMsg('❌ ' + (j.error || 'Σφάλμα')); return; }
    setMsg(row.is_active ? '⏸ Απενεργοποιήθηκε' : '▶ Ενεργοποιήθηκε'); await load();
  };

  const remove = async (row: any) => {
    if (!window.confirm(`Διαγραφή εταιρίας «${row.code} — ${row.name}»;`)) return;
    const r = await api('?action=delete', { method: 'POST', body: { code: row.code } });
    const j = await r.json();
    if (j.needs_deactivate) {
      if (window.confirm(`⚠️ ${j.message}`)) await toggleActive({ ...row, is_active: true });
      return;
    }
    if (!r.ok || !j.success) { setMsg('❌ ' + (j.error || 'Σφάλμα')); return; }
    setMsg('🗑 Διαγράφηκε'); await load();
  };

  const th: any = { textAlign: 'left', padding: '8px 10px', fontSize: 13, color: '#555', borderBottom: '2px solid #e0e0e0' };
  const td: any = { padding: '8px 10px', fontSize: 14, borderBottom: '1px solid #f0f0f0' };
  const btn: any = { padding: '5px 10px', borderRadius: 6, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', fontSize: 13, marginRight: 6 };
  const inp: any = { width: '100%', padding: '9px 11px', borderRadius: 7, border: '1px solid #ccc', fontSize: 14, boxSizing: 'border-box' };
  const fld = (label: string, key: string, opts: any = {}) => (
    <div style={{ marginBottom: 10 }}>
      <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>{label}{opts.req ? ' *' : ''}</label>
      <input style={{ ...inp, ...(opts.disabled ? { background: '#f1f1f1', color: '#888' } : {}) }} disabled={opts.disabled}
        value={editing[key] || ''} onChange={(ev) => setEditing((p: any) => ({ ...p, [key]: ev.target.value }))}
        placeholder={opts.ph || ''} />
    </div>
  );

  return (
    <div style={{ marginTop: 28 }}>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 12 }}>
        <h3 style={{ margin: 0, fontSize: 18 }}>🏢 Εταιρίες</h3>
        <button onClick={() => { setMsg(''); setEditing({ ...EMPTY, _isNew: true }); }}
          style={{ ...btn, background: '#1976d2', color: '#fff', border: 'none', fontWeight: 700 }}>+ Προσθήκη εταιρίας</button>
        <label style={{ marginLeft: 'auto', fontSize: 13, display: 'flex', alignItems: 'center', gap: 6 }}>
          <input type="checkbox" checked={showInactive} onChange={(e) => setShowInactive(e.target.checked)} /> Εμφάνιση ανενεργών
        </label>
      </div>

      {msg && <div style={{ marginBottom: 12, padding: 9, background: '#f0f4ff', borderRadius: 6, fontSize: 14 }}>{msg}</div>}
      {loading && <p style={{ color: '#888' }}>Φόρτωση…</p>}

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 620 }}>
          <thead><tr>
            <th style={th}>Διακριτικό</th><th style={th}>Επωνυμία</th><th style={th}>ΑΦΜ</th>
            <th style={th}>Τύπος</th><th style={th}>Κατάσταση</th><th style={th}></th>
          </tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.code} style={{ opacity: r.is_active ? 1 : 0.55 }}>
                <td style={{ ...td, fontWeight: 700 }}>{r.code}</td>
                <td style={td}>{r.name}</td>
                <td style={{ ...td, fontFamily: 'monospace' }}>{r.vat || '—'}</td>
                <td style={td}>{r.entity_type || '—'}</td>
                <td style={td}>{r.is_active
                  ? <span style={{ color: '#2e7d32', fontWeight: 700 }}>● Ενεργή</span>
                  : <span style={{ color: '#999' }}>○ Ανενεργή</span>}</td>
                <td style={{ ...td, whiteSpace: 'nowrap' }}>
                  <button style={btn} onClick={() => { setMsg(''); setEditing({ ...r, _isNew: false }); }}>✎ Επεξεργασία</button>
                  <button style={btn} onClick={() => toggleActive(r)}>{r.is_active ? '⏸ Απενεργ.' : '▶ Ενεργοπ.'}</button>
                  <button style={{ ...btn, color: '#c62828', borderColor: '#ef9a9a' }} onClick={() => remove(r)}>🗑</button>
                </td>
              </tr>
            ))}
            {rows.length === 0 && !loading && <tr><td style={td} colSpan={6}>Καμία εταιρία.</td></tr>}
          </tbody>
        </table>
      </div>

      {/* Form modal */}
      {editing && (
        <div style={overlay} onClick={() => setEditing(null)}>
          <div style={modal} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginTop: 0 }}>{editing._isNew ? '+ Νέα εταιρία' : 'Επεξεργασία: ' + editing.code}</h3>
            {fld('Διακριτικό (π.χ. NEPA3)', 'code', { req: true, disabled: !editing._isNew, ph: 'NEPA3' })}
            {fld('Επωνυμία', 'name', { req: true, ph: 'TAILWIND ΝΕΠΑ 3' })}
            {fld('ΑΦΜ', 'vat', { ph: '999999999' })}
            {fld('Αρμόδια ΔΟΥ', 'doy')}
            <div style={{ marginBottom: 10 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>Τύπος</label>
              <select style={inp} value={editing.entity_type || ''} onChange={(e) => setEditing((p: any) => ({ ...p, entity_type: e.target.value }))}>
                {types.map((t) => <option key={t} value={t}>{t}</option>)}
              </select>
            </div>
            {fld('Διεύθυνση', 'address')}
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '12px 0', fontSize: 14 }}>
              <input type="checkbox" checked={!!editing.is_active} onChange={(e) => setEditing((p: any) => ({ ...p, is_active: e.target.checked }))} /> Ενεργή
            </label>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button style={btn} onClick={() => setEditing(null)}>Ακύρωση</button>
              <button style={{ ...btn, background: '#2e7d32', color: '#fff', border: 'none', fontWeight: 700 }} onClick={save}>💾 Αποθήκευση</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const overlay: any = { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: 16 };
const modal: any = { background: '#fff', borderRadius: 12, padding: 22, maxWidth: 460, width: '100%', maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 8px 30px rgba(0,0,0,0.25)' };

export default EntitiesManager;
